import { useEffect } from 'react';

const BASE_URL = 'https://support.cryptofox.ru';
const INBOX_ID = '8b52b911-5200-4371-8d76-96cc91226a9f';
const SCRIPT_ID = 'libredesk-widget-script';

function getCsrfToken() {
    return (window.Params && window.Params.csrf_token) || '';
}

function initWidget(userJWT) {
    window.LibredeskSettings = {
        baseURL: BASE_URL,
        inboxID: INBOX_ID,
    };
    if (userJWT) {
        window.LibredeskSettings.userJWT = userJWT;
    }

    const existing = document.getElementById(SCRIPT_ID);
    if (existing) {
        if (userJWT && window.Libredesk && window.Libredesk.setUser) {
            window.Libredesk.setUser(userJWT);
        }
        return;
    }

    const script = document.createElement('script');
    script.id = SCRIPT_ID;
    script.async = true;
    script.src = `${BASE_URL}/widget.js`;
    document.body.appendChild(script);
}

function SupportWidget() {
    useEffect(() => {
        fetch('/admin/support-token', {
            credentials: 'same-origin',
            headers: { 'X-CSRF-Token': getCsrfToken() },
        })
            .then(r => (r.ok ? r.json() : null))
            .then(data => initWidget(data && data.token ? data.token : ''))
            .catch(() => initWidget(''));

        return () => {
            if (window.Libredesk && window.Libredesk.destroy) {
                window.Libredesk.destroy();
            }
        };
    }, []);

    return null;
}

export default SupportWidget;
